import { createModel } from "@/util/ModelUtil";

export default class SubscribeLectureInfoModel {
  constructor(
    public id: number = -1,
    public title: string = "",
    public type: string = "",
    public subscribeType: string = "",
    public startedAt: string = "",
    public endedAt: string = "",
    public organizationName: string = ""
  ) {}

  public static create(list?: SubscribeLectureInfo): SubscribeLectureInfoModel {
    return createModel<SubscribeLectureInfoModel>(
      SubscribeLectureInfoModel,
      list
    );
  }
}
